import { Form } from '@components/form/Form'
import { FormContextProvider } from '@contexts/FormContext'
import FormEditorHeader from '@layouts/components/FormEditorHeader'
import { FormItem } from '@models/FormItem'
import { FormPage } from '@models/FormPage'
import { getFormWithId, selectFormById, updateForm } from '@store/FormReducer'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { App, Flex, Spin, Typography } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const { Text } = Typography

const FormsEditPage = () => {
  const dispatch = useAppDispatch()
  const { message } = App.useApp()
  const { formId } = useParams<{ formId: string }>()

  const form = useAppSelector(selectFormById(Number(formId)))

  const { isLoading } = useAppSelector((state) => state.form)

  const validatePagesHaveItems = (pages: FormPage[]): boolean => {
    return pages.every((page) => page.items && page.items.length > 0)
  }

  const onSubmit = (values: any) => {
    if (!validatePagesHaveItems(values.pages)) {
      message.error('Chaque page doit contenir au moins un item')
      return
    }
    dispatch(
      updateForm({
        ...values,
        pages: values.pages.map((page: FormPage) => ({
          ...page,
          items: page.items.map((item: FormItem) => ({
            ...item,
            type: typeof item.type === 'object' ? item.type.id : item.type, // Remplace `type` par son `id`
            associatedItems: item.associatedItems?.map((associatedItem) => {
              return typeof associatedItem === 'object'
                ? associatedItem.id
                : associatedItem // Remplace `associatedItem` par son `id`
            }),
          })),
        })),
      } as any)
    ).then((response: any) => {
      message.success('Sauvegardé')
    })
  }

  useEffect(() => {
    if (!Number(formId)) return
    dispatch(getFormWithId(Number(formId)))
  }, [formId])

  if (!form) {
    return (
      <Flex>
        <Text>Chargement du formulaire...</Text>
        <Spin />
      </Flex>
    )
  }

  return (
    <FormContextProvider initialValue={form} onSubmit={onSubmit}>
      <FormEditorHeader />
      {isLoading && <Spin />}
      <Form.Wrapper />
    </FormContextProvider>
  )
}

export default FormsEditPage
